import React from 'react';

import { useParams } from 'react-router-dom';
import Tractors from '../../components/Tractors/Tractors';
import Combines from '../../components/Combines/Combines';
import Agregates from '../../components/Agregates/Agregates';
import ErrorPage from '../ErrorPage/ErrorPage';
import ProductProperties from '../../components/PropertyProduct';

function CategoryPage() {
  const { categoryName } = useParams();

  let categoryPageView = null;

  if (categoryName === 'traktorlar') {
    categoryPageView = <Tractors />;
  } else if (categoryName === 'kombaynlar') {
    categoryPageView = <Combines />;
  } else if (categoryName === 'aqreqatlar') {
    categoryPageView = <Agregates />;
  }
  else if (categoryName === "məhsul") {
    categoryPageView = <ProductProperties />
  }

  else {
    categoryPageView = <ErrorPage />;
  }

  return <div>{categoryPageView}</div>;
}

export default CategoryPage;
